import { Injectable, inject } from '@angular/core';
import { LanguageToken } from '@app/core/env.tokens';
import type { LanguageCode } from '@handyhand/i18n';
import * as da from '../../../assets/i18n/da.json';
import * as en from 'assets/i18n/en.json';
import * as nl from 'assets/i18n/nl.json';
const TRANSLATIONS: Record<LanguageCode, any> = {
  da,
  en,
  nl,
};

@Injectable({
  providedIn: 'root',
})
export class TranslateService {
  private readonly defaultLanguage: LanguageCode = inject(LanguageToken);

  data: any;

  constructor() {
    this.data = TRANSLATIONS[this.defaultLanguage];
  }

  use(lang: LanguageCode): void {
    this.data = TRANSLATIONS[lang];
  }
}
